import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Portfolio from '../components/Portfolio';
import SEO from '../components/SEO';

const PortfolioPage = () => {
  return (
    <>
      <SEO 
        title="Our work | CodeRidge — Cloud, Security, Product & EdTech Delivery"
        description="Our work in the open: secure web and mobile products, cloud-backed platforms, commerce at scale, and Kidsphere—examples of CodeRidge's enterprise-grade engineering and operations mindset."
        keywords="CodeRidge portfolio, cloud projects, secure web applications, mobile engineering, EdTech Kidsphere, observability, enterprise delivery"
        url="https://coderidge.in/portfolio"
      />
      <Navbar />
      <div style={{ paddingTop: '80px' }}>
        <Portfolio />
      </div>
      <Footer />
    </>
  );
};

export default PortfolioPage;










